




























































import Vue, { PropType } from 'vue';
import Icon from '~/components/builders/Base/Icon.vue';

// Types and services
import {
    CandidateProfileScore,
    CandidateProfileStatus,
} from '~/utils/candidate/CandidateProfileScorer';

// Components
import Card from './Card.vue';

export default Vue.extend({
    name: 'ProfileScore',
    components: { Card, Icon },
    props: {
        score: {
            type: Object as PropType<CandidateProfileScore>,
            required: true,
        },
    },
    computed: {
        progress(): number {
            return this.score.progress;
        },
        isCompleted(): boolean {
            return this.score.status === CandidateProfileStatus.COMPLETE;
        },
    },
});
